import {Component,Input} from '@angular/core';
import {Router} from '@angular/router';

import {Session} from '@domain/security/session';

/**
 * Footer commun de l'application
 */
@Component({
    selector: 'nio-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

    /** Session courante */
    @Input()
    public session: Session;

    /** Année courante */
    public currentYear: number = new Date().getFullYear();

    /**
     * Constructeur par défaut
     */
    constructor(private router: Router) {
    }

    /**
     * Navigation vers un onglet du profil utilisateur.
     * Passe par /Blank pour forcer la ré-instanciation de ProfilComponent
     * lorsque l'utilisateur est déjà sur /Profil.
     * @param tabCode Code de l'onglet à afficher
     */
    navigateToProfileTab(tabCode: string): void {
        this.router.navigateByUrl('/Blank', {skipLocationChange: true}).then(() => {
            this.router.navigate(['/Profil'], {state: {tab: tabCode}});
        });
    }
}
